import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {TableAttachDocumentsWrapper} from '../Tables/TableAttachDocuments'
import {TableBookingNotesWrapper} from '../Tables/TableBookingNotes'
import {TableBookingDetailsWrapper} from '../Tables/TableDetails'

const DetailBookingPanel: FC = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            {isAllowed('HUESPED/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Huesped</Tab>
            )}
            {isAllowed('ADJUNTARDOCUMENTOS/ACCESO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Adjuntar Documentos</Tab>
            )}
            {isAllowed('NOTAS/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>Notas</Tab>}
          </TabList>
          {/* <TabPanel>
            <FormBooking />
          </TabPanel> */}
          {isAllowed('HUESPED/ACCESO') && (
            <TabPanel>
              <TableBookingDetailsWrapper />
            </TabPanel>
          )}
          {isAllowed('ADJUNTARDOCUMENTOS/ACCESO') && (
            <TabPanel>
              <TableAttachDocumentsWrapper />
            </TabPanel>
          )}
          {isAllowed('NOTAS/ACCESO') && (
            <TabPanel>
              <TableBookingNotesWrapper />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export {DetailBookingPanel}
